export default {
      id: "ic_nav_tribun-usage",
      viewBox: "0 0 48 30",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_tribun-usage",
      toString: function () {
        return this.url;
      }
    }